/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Complete_Select_RecommendationInputs */

const en_task_complete_select_recommendation = /** @type {(inputs: Task_Complete_Select_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a recommendation before completing this task.`)
};

const pt_br2_task_complete_select_recommendation = /** @type {(inputs: Task_Complete_Select_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma recomendação antes de concluir esta atividade.`)
};

/**
* | output |
* | --- |
* | "Select a recommendation before completing this task." |
*
* @param {Task_Complete_Select_RecommendationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_select_recommendation = /** @type {((inputs?: Task_Complete_Select_RecommendationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Select_RecommendationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_select_recommendation(inputs)
	return pt_br2_task_complete_select_recommendation(inputs)
});